var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import retrieveUserAnswers from './helpers';
export var initialState = [];
var userAnswersSlice = createSlice({
    name: 'userAnswers',
    initialState: initialState,
    reducers: {
        updateUserAnswers: function (userAnswers, action) {
            var userAnswer = action.payload;
            var indexOfPreviouslyAnsweredQuestion = userAnswers.findIndex(function (previousAnswer) { return (previousAnswer === null || previousAnswer === void 0 ? void 0 : previousAnswer.id) === userAnswer.id; });
            var updatedUserAnswers;
            if (indexOfPreviouslyAnsweredQuestion >= 0) {
                updatedUserAnswers = retrieveUserAnswers({
                    userAnswers: userAnswers,
                    userAnswer: userAnswer,
                    indexOfPreviouslyAnsweredQuestion: indexOfPreviouslyAnsweredQuestion
                });
            }
            else {
                updatedUserAnswers = __spreadArray(__spreadArray([], userAnswers, true), [userAnswer], false);
            }
            return updatedUserAnswers;
        },
        updateAdditionalContent: function (userAnswers, action) {
            var _a = action.payload, currentAnswerId = _a.currentAnswerId, additionalContent = _a.additionalContent, _b = _a.isEligibleForPartialAmount, isEligibleForPartialAmount = _b === void 0 ? false : _b, _c = _a.isAmount, isAmount = _c === void 0 ? false : _c;
            var updateCurrentUserAnswer = function (userAnswer) {
                if (userAnswer.id === currentAnswerId) {
                    var answerCopy = __spreadArray([], userAnswer.answers, true);
                    if (answerCopy.length === 0) {
                        answerCopy.push(additionalContent);
                    }
                    else {
                        answerCopy[1] = additionalContent;
                    }
                    return __assign(__assign({}, userAnswer), { isEligibleForPartialAmount: isEligibleForPartialAmount, answers: answerCopy, type: isAmount ? 'AMOUNT' : 'TEXTFIELD' });
                }
                return userAnswer;
            };
            return userAnswers.map(updateCurrentUserAnswer);
        },
        clearUserAnswers: function () {
            return initialState;
        }
    }
});
export var updateUserAnswers = (_a = userAnswersSlice.actions, _a.updateUserAnswers), updateAdditionalContent = _a.updateAdditionalContent, clearUserAnswers = _a.clearUserAnswers;
export default userAnswersSlice.reducer;
//# sourceMappingURL=userAnswers.slice.js.map